export const REQUIRED_GROUP_TYPES = {
    requester: 'task-requester',
    recipient: 'task-recipient',
    volunteer: 'task-volunteer',
}
